export default function (pwz) {

    pwz = pwz.trim()

    if (/^[0-9]{5}$/.test(pwz) === false)
        return false

    return true
}